
import { useEffect, useState } from 'react';
import { COUPON_TYPE, DEPOSITE_TYPE, useStyles, yesNoList, statusList, statusList_2 } from '../../constant/constant.js';
import { Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, Box } from '@mui/material';
import { apiBaseUrl } from '../../constant/endpoint.js';
import { axiosRequest } from '../../utility/axios.js';
import { useSelector } from 'react-redux';
import CustomizedButtons from '../../components/button/button.js';
// import { Heading } from '../contests/contest.js';
// import { MainBox } from '../user/editUserInfo.js';
import InputTextField from '../../components/textBox/borderTextField.js';
import { InputLabel } from '@mui/material';
import { TextField } from '@mui/material';
import SelectTextFields from '../../components/customDropDown/dropDown.js';
import SelectDropDown from '../../components/customDropDown/customDropDown.js';
import DateTimePicker from '../../components/datePicker/dateTimePicker';
import { isEmpty } from 'lodash';
import { getSweetAlert } from '../../helper/index.js';
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import { Heading, MainBox } from './paymentOffer.js';

const EditPaymentOffer = () => {
    const [paymentOffer, setPaymentOffer] = useState({});
    const [disable, setDisable] = useState(true);
    const [uid, setUid] = useState("");
    const [usageLimit, setUsageLimit] = useState("");

    const navigate = useNavigate();
    const loginSlice = useSelector(state => state.loginSlice);
    const token = loginSlice.token;


    const handleSearch = async (id) => {
        const url = `/paymentOffers/details?id=${id}`;
        const res = await axiosRequest("GET", url, token);

        if (res?.status === "success") {
            setPaymentOffer(res.data[0]);
            console.log("res.data[0]", res.data[0]);
        }
    }
    const validateForm = () => {
        let status = true
        
        if (isEmpty(paymentOffer.coupon_code)) {
            status = false
            getSweetAlert('error', 'Enter the coupon code')
        } else if (!paymentOffer.min_amount) {
            status = false
            getSweetAlert('error', 'Enter the min amount')
        } else if (!paymentOffer.max_cashback_amount) {
            status = false
            getSweetAlert('error', 'Enter the max_cashback_amount')
        } else if (paymentOffer.unlimited_usage_limit == "no" && isEmpty(paymentOffer.usage_limit)) {
            status = false
            getSweetAlert('error', 'Enter the usage limit')
        } else if (!paymentOffer.max_cashback_percent) {
            status = false
            getSweetAlert('error', 'Enter the max_cashback_percent')
        } else if (isEmpty(paymentOffer.per_user_limit)) {
            status = false
            getSweetAlert('error', 'Enter the per user limit')
        } else if (!paymentOffer.expiry_date || !moment(paymentOffer.expiry_date).isValid()) {
            status = false
            getSweetAlert('error', 'Enter the expiry_date')
        } 
        return status
    }

    const handleSubmit = async () => {
        if (!validateForm()) return;
        // paymentOffer["first_deposite"] = paymentOffer.first_deposite == "Active" ? 1 : 0;
        // paymentOffer["status"] = paymentOffer.status == "Active" || paymentOffer.status == 1 ? 1 : 0;
       
        const url = `${apiBaseUrl}/paymentOffers/status?id=${uid}`;
        const res = await axiosRequest("PUT", url, token, paymentOffer);

        if (res?.status === "success") {
            setPaymentOffer(res.data);
            getSweetAlert("success", "Successfully Update!!!")
            navigate("/payment-offer")
        }
    }
    const handleDateChange = (date, key) => {
        const updateDate = moment(date); // 
        setPaymentOffer((prevState) => ({
            ...prevState,
            [key]: updateDate.clone().toDate()
        }));
    };

    const handleChange = (event) => {
        let { name, value } = event.target;
        if (name == "coupon_code") {
            console.log("value",value);
            value = value.toUpperCase().replace(/[^\w\d]/g, ""); 
            if( value.length <= 8){
                setPaymentOffer(prevState => ({
                    ...prevState,
                    [name]: value
                }));
            }
        } else {
            const limits = {

                min_amount: [1, 50000],
                max_cashback_amount: [1, 50000],
                max_amount: [0, 50000],
                max_cashback_percent: [1, 500],
                usage_limit: [1, 100000],
                per_user_limit: [1, 100000],
                // sequence: [1, 10000]
            };
        
            if (limits[name]) {
                
                value = value == 0 || value == "-" ? "" : value;
                if (value === "" || (value >= limits[name][0] && value <= limits[name][1])) {
                    setPaymentOffer(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                return;
            }
           
        }
       
    };

    const handleDropDown = (name, value, _id) => {
        console.log("name value", name , value, _id);
        if(name == "unlimited_usage_limit" && _id == 1){
            setDisable(true);
            setUsageLimit(paymentOffer.usage_limit);
            paymentOffer.usage_limit = "unlimited";
        } else if(name == "unlimited_usage_limit" && _id == 0){
            setDisable(false);
            paymentOffer.usage_limit = usageLimit;
        };
        setPaymentOffer(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    

    useEffect(() => {
        const path = window.location.pathname;
        const id = path.split('/')[3];
        handleSearch(id);
        setUid(id);
    }, [window.location.pathname]);

    return (
        <Box sx={{ width: '100%', typography: 'body1', marginTop: "100px" }}>
            <MainBox>
                <Heading fontSize={"26px"} fontWeight={"600"} textAlign={"center"}>*All fields are required</Heading>

                <Grid container spacing={2} mt={1}>
                <Grid item lg={6} xs={12}>
                    {/* <InputLabel >Is Public</InputLabel> */}
                         <SelectDropDown
                            label="Is Public"
                            name="is_public"
                            value={paymentOffer.is_public == true ? "yes" : "no"}
                            handleOnChange={handleDropDown}
                            list={yesNoList}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                    {/* <InputLabel >Is First Time Deposite Offer</InputLabel> */}
                         <SelectDropDown
                            label={"First Deposite"}
                            name={"first_deposite"}
                            value={paymentOffer?.first_deposite == 0 ? 0 : 1}
                            // value={paymentOffer.first_deposite == 1 ? "Active" : "Inactive"} // Correctly mapped value from the state
                            handleOnChange={handleDropDown}
                            list={statusList_2}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        {/* <InputLabel >Coupon Type</InputLabel> */}
                        <SelectDropDown
                            label="Coupon Type"
                            name="coupon_type"
                            value={paymentOffer.coupon_type || ''}
                            handleOnChange={handleDropDown}
                            list={COUPON_TYPE}
                        />
                    </Grid>

                    <Grid item lg={6} xs={12}>
                        {/* <InputLabel >Deposite Type</InputLabel> */}
                        <SelectDropDown
                            label="Deposite Type"
                            name="deposite_type"
                            value={paymentOffer.deposite_type || ''}
                            handleOnChange={handleDropDown}
                            list={DEPOSITE_TYPE}
                        />
                    </Grid>

                    <Grid item lg={6} xs={12}>
                        <InputLabel >Enter min 3 max 8 Digit Coupon Type</InputLabel>
                        <InputTextField
                            type="text"
                            onChange={handleChange}
                            value={paymentOffer?.coupon_code}
                            name={"coupon_code"}
                        />
                    </Grid>

                    <Grid item lg={6} xs={12}>
                        <InputLabel >Minimum Amount (INR)</InputLabel>
                        <InputTextField
                            type="text"
                            onChange={handleChange}
                            value={paymentOffer?.min_amount}
                            name={"min_amount"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <InputLabel >Maximum Amount (INR)</InputLabel>
                        <InputTextField
                            type="text"
                            onChange={handleChange}
                            value={paymentOffer?.max_amount}
                            name={"max_amount"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <InputLabel >Maximum Cashback Amount (INR)</InputLabel>
                        <InputTextField
                            type="text"
                            onChange={handleChange}
                            value={paymentOffer?.max_cashback_amount}
                            name={"max_cashback_amount"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <InputLabel >Cashback Percentage (%)</InputLabel>
                        <InputTextField
                            type="text"
                            onChange={handleChange}
                            value={paymentOffer?.max_cashback_percent}
                            name={"max_cashback_percent"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <InputLabel >Limit Per User</InputLabel>
                        <InputTextField
                            type="text"
                            onChange={handleChange}
                            value={paymentOffer?.per_user_limit}
                            name={"per_user_limit"}
                        />
                    </Grid>
                   
                    <Grid item lg={6} xs={12}>
                        <InputLabel >Usage Limit</InputLabel>
                        <InputTextField
                            type="text"
                            disabled={paymentOffer.usage_limit == "unlimited" ? true : false}
                            onChange={handleChange}
                            value={paymentOffer?.usage_limit == "unlimited" ? "" : paymentOffer?.usage_limit}
                            name={"usage_limit"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                    {/* <InputLabel >Unlimited Usage Limit</InputLabel> */}
                         <SelectDropDown
                            label="Unlimited Usage Limit"
                            name="unlimited_usage_limit"
                            value={paymentOffer.usage_limit == "unlimited" ? "yes" : "no"}
                            handleOnChange={handleDropDown}
                            list={yesNoList}
                        />
                    </Grid>
                    {/* <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="Number"
                            label="Sequence"
                            // disabled={disable}
                            onChange={handleChange}
                            value={paymentOffer?.sequence || ''}
                            name={"sequence"}
                        />
                    </Grid> */}
                    <Grid item lg={6} xs={12}>
                    {/* <InputLabel >Status</InputLabel> */}
                         <SelectDropDown
                            label=""
                            name="status"
                            value={paymentOffer.status == 1 ? 1 : 0}
                            handleOnChange={handleDropDown}
                            list={statusList_2}
                        />
                    </Grid>
                    
                    <Grid item lg={6} xs={12}>
                        {/* <InputLabel >Expires On</InputLabel> */}
                        <DateTimePicker label={"Expires On"}  name={'expiry_date'} value={paymentOffer?.expiry_date} handleOnChange={(date) => handleDateChange(date, "expiry_date")} />
                    </Grid>
                    {/* <Grid item lg={6} xs={12}>
                        <InputLabel >Expires Time</InputLabel>
                        <CustomDatePicker label={"Expire Time"}  name={'expiry_date'}></CustomDatePicker>
                    </Grid> */}
                    {/* <Grid item lg={6} xs={12}>
                        <InputLabel >Description</InputLabel>
                        <InputTextField
                            type="text"
                            onChange={handleChange}
                            value={paymentOffer?.description}
                            name={"description"}
                        />
                    </Grid> */}
                    
                    <Grid item lg={6} xs={12}>
                        <CustomizedButtons color="success" label="Update Offer" variant={"contained"} onClick={handleSubmit} />
                    </Grid>

                </Grid>
            </MainBox>
        </Box>

    );
}


export default EditPaymentOffer;
